var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.local_color_grid &&
      _vm.local_color_grid.num_rows &&
      _vm.local_color_grid.num_columns
  )?_c('div',_vm._l((_vm.getArrayFromLength(_vm.local_color_grid.num_rows)),function(i,row_index){return _c('div',{key:`ROW${row_index}`,staticClass:"grid-rows"},_vm._l((_vm.getArrayFromLength(
        _vm.local_color_grid.num_columns
      )),function(j,col_index){return _c('div',{key:`COLUMN${row_index}-${col_index}`,ref:"box",refInFor:true,staticClass:"grid-columns",style:(`background: ${_vm.setColor(row_index, col_index)};height: ${
          _vm.getBoxDimensions.height
        }px; width: ${_vm.getBoxDimensions.width}px; border: 1px solid ${
          _vm.local_color_grid.box_styles.border_color
        }`),on:{"mousedown":function($event){$event.preventDefault();return _vm.mouseDown(row_index, col_index)},"mouseup":function($event){$event.preventDefault();return _vm.mouseUp(row_index, col_index)},"mouseover":function($event){$event.preventDefault();return _vm.mouseOver(row_index, col_index)}}})}),0)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }